module.exports = __webpack_public_path__ + "static/media/14S.1b968ecf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/14S.svg
// module id = 52
// module chunks = 0